<template>
  <span>    
    <span v-show="item.edited == '1'">
      <div v-if="item.output == 'list'" class="editForm mt-1">        
        <p v-for="(object,index) in optionChecked" :key="index">  
          - <span v-if="object.type == 'input'">{{object.text}}</span><span v-if="object.type == 'text'">{{object.title}}</span>
        </p>
        <i class="fal fa-times-circle" @click="removeEdit"  v-b-tooltip.hover :title="$t('TEMPLATE.FORM.REMOVE')" />
      </div>
      <span v-if="item.output == 'line'" class="editForm">
        <span v-for="(object,index) in optionChecked" :key="index">
          <span v-if="index > 0">, </span>
          <span v-if="object.type == 'input'">{{object.text}}</span>
          <span v-if="object.type == 'text'">{{object.title}}</span>
        </span>
        <i class="fal fa-times-circle" @click="removeEdit"  v-b-tooltip.hover :title="$t('TEMPLATE.FORM.REMOVE')" />
      </span>
    </span>
    <b-card no-body v-show="item.edited == '0'" class="mt-2">      
      <b-card-body>
        <div v-for="(object,index) in item.items" :key="index">           
          <b-form-checkbox v-model="object.value" value="1" unchecked-value="0">
              {{object.title}}
              <b-form-input v-model="object.text" v-if="object.type == 'input'"></b-form-input>          
          </b-form-checkbox>
        </div>              
      </b-card-body>
      <b-card-footer>
        <b-button class="float-right mt-2 btn-fill" @click="saveForm">Save</b-button>
      </b-card-footer>
    </b-card>
  </span>
</template>
<script>
export default {
  props: ["value", "id","templateId"],
  data() {
    return {
      item: this.value,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    saveForm: function() {
      this.item.edited = "1";      
      let self = this;
      let jsonString = JSON.stringify(this.item.items);
      this.$http.post(process.env.VUE_APP_BACKEND + "/template/document/answer/update", {
        templateId: this.templateId,
        answers:  [{
          key: this.item.id,
          value: jsonString
        }]
      })
      .then(function() {
        self.item.edited = "1";
        self.$emit("input",self.item);
      })
      .catch(function() {
        self.item.edited = "0";
        self.$noty.error(self.$t("ERROR.COULD_NOT_SAVE"));
      });
    },
    removeEdit: function() {     
      this.item.edited = "0";
    }
  },
  mounted() {    
    if(this.item.edited == '1'){      
      this.item.items = JSON.parse(this.item.value);
    }        
  },
  computed: {
    isDisabled() {
      if (this.selectedList.length != 0) {
        return false;
      } else {
        return true;
      }
    },
    optionChecked: function() {
      return this.item.items.filter(function(item) {
        return item.value == '1';
      })
    }
  }
};
</script>
<style>
</style>